import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import type { JSX, ReactNode, SVGProps } from 'react';

type Icon = (props: SVGProps<SVGSVGElement>) => JSX.Element;

interface Props {
  readonly icon: Icon;
  readonly title: string | JSX.Element;
  readonly bodyElement?: 'p' | 'div' | 'ul';
  readonly children: ReactNode;
}

const DescriptionItem = ({
  icon: Icon,
  title,
  bodyElement = 'p',
  children,
}: Props): JSX.Element => {
  return (
    <li className="mb-10">
      <div className="mb-3 flex flex-row-reverse justify-end gap-3">
        <Typography Element="h3" variant="h6" weight="normal" color="inherit">
          {title}
        </Typography>

        <span
          role="presentation"
          className={cx(
            'inline-flex items-center justify-center',
            'h-8 w-8 shrink-0',
            'rounded-lg border',
            'border-current',
          )}
        >
          <Icon width={16} height={16} />
        </span>
      </div>

      <Typography Element={bodyElement} color="inherit">
        {children}
      </Typography>
    </li>
  );
};

export default DescriptionItem;
